import { db } from "../../services/firebase/Config";

import {
  FETCH_PRESTATIONS_REQUEST,
  FETCH_PRESTATIONS_SUCCESS,
  FETCH_PRESTATIONS_FAILURE,
  ADD_PRESTATION,
  REMOVE_PRESTATION_IN_ARRAY,
  UPDATE_PRESTATION_IN_ARRAY,
  UPDATE_LAB_IN_PRESTATION_IN_ARRAY,
  SAVE_PRESTATION_REQUEST,
  SAVE_PRESTATION_SUCCESS,
  SAVE_PRESTATION_FAILURE,
  NEW_PRESTATIONS,
} from "./prestationsTypes";

import { httpRequest, httpSuccess, httpFailure } from "../sesion/sesionActions";
import { setEstadoCompletado } from "../sesion/sesionActions";

const fetchPrestationsRequest = () => {
  return {
    type: FETCH_PRESTATIONS_REQUEST,
  };
};

const fetchPrestationsSuccess = (payload) => {
  return {
    type: FETCH_PRESTATIONS_SUCCESS,
    payload,
  };
};

const fetchPrestationsFailure = (payload) => {
  return {
    type: FETCH_PRESTATIONS_FAILURE,
    payload,
  };
};

// ADD PRESTATION

const savePrestationRequest = () => {
  return {
    type: SAVE_PRESTATION_REQUEST,
  };
};

export const newPrestations = () => {
  return {
    type: NEW_PRESTATIONS,
  };
};

const savePrestationSuccess = () => {
  return {
    type: SAVE_PRESTATION_SUCCESS,
  };
};

const savePrestationFailure = (error) => {
  return {
    type: SAVE_PRESTATION_FAILURE,
    payload: error,
  };
};

export const addPrestation = (payload) => {
  return {
    type: ADD_PRESTATION,
    payload,
  };
};

export const updatePrestationInArray = (payload) => {
  return {
    type: UPDATE_PRESTATION_IN_ARRAY,
    payload,
  };
};

export const updateLabInPrestationInArray = (payload) => {
  return {
    type: UPDATE_LAB_IN_PRESTATION_IN_ARRAY,
    payload,
  };
};

// Remove Prestation
export const removePrestationInArray = (prestation) => {
  return {
    type: REMOVE_PRESTATION_IN_ARRAY,
    payload: prestation,
  };
};

export const addPrestationDb = (prestacion) => {
  return async function (dispatch, getState) {
    const empresaId = prestacion.empresaId || getState().paciente.empresaId;

    // Obtener el tiempo del tratamiento si no está definido
    if ((prestacion.tiempo === undefined || prestacion.tiempo === null || prestacion.tiempo === "") && prestacion.tratamientoId) {
      try {
        let tiempo = 30; // valor por defecto
        
        // 1. Buscar en tratamientos personalizados de la empresa
        const customDoc = await db
          .collection("empresas")
          .doc(empresaId)
          .collection("tratamientos")
          .doc(prestacion.tratamientoId)
          .get();
          
        let found = false;
        if (customDoc.exists) {
          const data = customDoc.data();
          if (data.tiempo !== undefined && data.tiempo !== null && data.tiempo !== "") {
            tiempo = Number(data.tiempo);
            found = true;
          } else if (data.tiempoSugerido !== undefined && data.tiempoSugerido !== null && data.tiempoSugerido !== "") {
            tiempo = Number(data.tiempoSugerido);
            found = true;
          }
        }
        
        if (!found) {
          // 2. Buscar en tratamientos base
          const baseDoc = await db
            .collection("tratamientos_base")
            .doc(prestacion.tratamientoId)
            .get();
            
          if (baseDoc.exists) {
            const data = baseDoc.data();
            if (data.tiempo !== undefined && data.tiempo !== null && data.tiempo !== "") {
              tiempo = Number(data.tiempo);
            } else if (data.tiempoSugerido !== undefined && data.tiempoSugerido !== null && data.tiempoSugerido !== "") {
              tiempo = Number(data.tiempoSugerido);
            }
          }
        }
        prestacion.tiempo = tiempo;
      } catch (err) {
        console.error("Error al obtener tiempo del tratamiento:", err);
        prestacion.tiempo = 30;
      }
    } else if (prestacion.tiempo === undefined || prestacion.tiempo === null || prestacion.tiempo === "") {
      prestacion.tiempo = 30;
    } else {
      prestacion.tiempo = Number(prestacion.tiempo); // Asegurar que sea número
    }

    const prestacionRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(prestacion.pacienteId).collection("prestaciones").doc();
    dispatch(savePrestationRequest());
    prestacion.id = prestacionRef.id;
    return prestacionRef
      .set(Object.assign({}, prestacion))
      .then((docRef) => {
        dispatch(savePrestationSuccess());
        dispatch(addPrestation(prestacion));
        return prestacion.id;
      })
      .catch((err) => {
        dispatch(savePrestationFailure(err));
        throw err;
      });
  };
};

export const fetchPrestations = (pacienteId, empresaId) => {
  return function (dispatch) {
    dispatch(fetchPrestationsRequest());
    let prestaciones = [];
    return db.collection("empresas").doc(empresaId).collection("pacientes").doc(pacienteId).collection("prestaciones")
      .where("estado", "in", ["TERMINADO", "ACTIVO", "PENDIENTE"])
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          prestaciones.push({
            id: doc.id,
            tratamiento: doc.data().tratamiento,
            tipo: doc.data().tipo,
            precio: Number(doc.data().precio),
            precioOrigin: Number(doc.data().precioOrigin),
            dscto: Number(doc.data().dscto),
            dientes: doc.data().dientes,
            pagado: Number(doc.data().pagado),
            estado: doc.data().estado,
            estfin: doc.data().estfin,
            caras: doc.data().caras,
            pacienteId: doc.data().pacienteId,
            notasClinicas: doc.data().notasClinicas,
            config: doc.data().config,
            lab: doc.data().lab,
            tratamientoId: doc.data().tratamientoId,
            nota: doc.data().nota,
            fechaFin: (doc.data().fechaFin && typeof (doc.data().fechaFin) == 'object') ? doc.data().fechaFin.toDate() : doc.data().fechaFin,
            costo: doc.data().costo,
            tiempo: doc.data().tiempo !== undefined ? Number(doc.data().tiempo) : 30
          });
        });
        dispatch(fetchPrestationsSuccess(prestaciones));
        dispatch(
          setEstadoCompletado({
            prestaciones: true,
          })
        );
      })
      .catch((err) => {
        dispatch(fetchPrestationsFailure(err));
        throw err;
      });
  };
};

export const fetchPrestacionesAdeudadas = async (pacienteId, empresaId) => {
  let prestaciones = [];
  await db.collection("empresas").doc(empresaId).collection("pacientes").doc(pacienteId).collection("prestaciones")
    .where("estfin", "==", "PENDIENTE")
    .where("estado", "in", ["TERMINADO", "ACTIVO", "PENDIENTE"])
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        prestaciones.push({
          id: doc.id,
          tratamiento: doc.data().tratamiento,
          tipo: doc.data().tipo,
          precio: Number(doc.data().precio),
          dientes: doc.data().dientes,
          pagado: Number(doc.data().pagado),
          estado: doc.data().estado,
          estfin: doc.data().estfin,
          caras: doc.data().caras,
          pacienteId: doc.data().pacienteId,
          notasClinicas: doc.data().notasClinicas,
          config: doc.data().config,
          estlab: doc.data().estlab,
          nota: doc.data().nota,
          tiempo: doc.data().tiempo !== undefined ? Number(doc.data().tiempo) : 30
        });
      });
    })
    .catch((err) => {
      console.log("error getting documento" + err);
    });

  return prestaciones;
};
